import { BadgeCheck, Scale, Target } from "lucide-react";

const SLUG = "outsourced-financial-management";

/**
 * A restrained credibility strip, directly under the hero.
 *
 * This is a monthly engagement of real size, so the page has to answer "why
 * would I let this firm run my finance function?" early. Three short claims on
 * a hairline strip - no logos, no badges, no qualification wall.
 */
const POINTS = [
  {
    icon: BadgeCheck,
    title: "Experienced finance leadership",
    text: "Senior finance and financial management experience leading the function.",
  },
  {
    icon: Scale,
    title: "Professional financial oversight",
    text: "Finance processes, reporting and controls supported by experienced professionals.",
  },
  {
    icon: Target,
    title: "Practical business perspective",
    text: "Financial management focused on information management can actually use.",
  },
];

export const FinanceTrust = () => (
  <section
    data-testid={`${SLUG}-trust`}
    className="border-y border-border bg-white py-7 sm:py-8"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <dl className="grid grid-cols-1 gap-6 sm:grid-cols-3 sm:gap-8">
        {POINTS.map(({ icon: Icon, title, text }, index) => (
          <div
            key={title}
            data-testid={`${SLUG}-trust-${index + 1}`}
            className="flex gap-3.5 sm:border-l sm:border-border sm:pl-5 sm:first:border-l-0 sm:first:pl-0"
          >
            <Icon
              className="mt-[3px] h-4 w-4 shrink-0 text-[color:var(--tt-accent)]"
              aria-hidden="true"
            />
            <div>
              <dt className="text-[12px] font-bold uppercase leading-tight tracking-[0.09em] text-foreground">
                {title}
              </dt>
              <dd className="mt-1.5 text-[13px] leading-relaxed text-muted-foreground">
                {text}
              </dd>
            </div>
          </div>
        ))}
      </dl>
    </div>
  </section>
);
